import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from '../../config/api'
import ReactPlayer from 'react-player';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom'
import ScrollToTopOnMount from '../ScrollToTopOnMount';

import IconSetMenu from '../Icon/IconSetMenu';
import Spinner from '../Spinner';

import './Fiche.css';

import {
  fetchData,
  getDataFiche,
  getLoadingError,
} from '../../ducks/asyncFetcher';


import IconPrint from '@material-ui/icons/Print';
import IconPlay from '@material-ui/icons/PlayCircleFilledWhite';
import IconLanguage from '@material-ui/icons/Language';
import IconChat from '@material-ui/icons/ChatBubbleOutline';

import IconCar from '@material-ui/icons/DirectionsCar';
import IconSalary from '@material-ui/icons/EuroSymbol';
import IconCalendar from '@material-ui/icons/DateRange';
import IconMobility from '@material-ui/icons/LocationCity';
import IconCity from '@material-ui/icons/Place';
import IconMore from '@material-ui/icons/ExpandMore';
import IconLess from '@material-ui/icons/ExpandLess';



import BlockRatio from '../BlockRatio/BlockRatio';

const AF_KEY = 'fiche';

class MissionFicheBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {overflows: false, show: false, refHeight: 0, height: 'auto'};
  }
  componentDidMount() {
    // console.log('MOUNTED', this.props.more, this.$ref.offsetHeight, HEIGHT_THRESHOLD)
    const t = this._getHeightThreshold();
    if (this.props.more !== false && this.$ref.offsetHeight > t) {
      this.setState({overflows: true, refHeight: this.$ref.offsetHeight, height: t})
    }
  }
  _getHeightThreshold() {
    const { width, printing } = this.props;
    // console.log(printing)
    // console.log(printing)
    // console.log(printing)
    let t;
    if (printing)
      t = 'auto';
    else if (width === 'xs')
      t = 89;
    else
      t = 119;
      return t;
  }
  _onClick(e) {
    const t = this._getHeightThreshold();
    this.setState({show: !this.state.show, height: !this.state.show ? this.state.refHeight : t});
  }
  render() {
    const { title, content, more } = this.props;
    const { overflows, show } = this.state;
    return <span className={'padder'+(overflows?' minimal' : '')+(show ? ' show': '')}>
      <h4>{title}</h4>
      <span className="content" style={{height: this.state.height}} ref={(r) => this.$ref = r} dangerouslySetInnerHTML={{__html:content}}></span>
      <If condition={more !== false}>
        <button className="more"  onClick={this._onClick.bind(this)}>
          <If condition={!show}>
            <IconMore className="icon"/> Voir Plus
            </If>
            <If condition={show}>
              <IconLess className="icon"/> Fermer
              </If>
            </button>
          </If>
        </span>

      }
    }

    const MISSION_ID_360 = 'preview';

    class MissionFiche extends Component {
      constructor(props) {
        super(props);
        this.state = {
          printing: false,
          autoPlay: false,
          videoUrl: undefined,
          modalState: false
        };
        this._modalOpen = this._modalOpen.bind(this);
        this._modalClose = this._modalClose.bind(this);
      }
      componentDidMount() {
        const { missionId, ficheId, profile, anon } = this.props;
        let url;
        if (!anon && !profile)
          url = config.fiche.replace(':missionId', missionId).replace(':ficheId', ficheId);
        else if (profile)
          url = config.profile;
        this.props.onMount(url);
        const URI = queryString.parse(this.props.location.search);

        if (URI.print === 'true') {
          document.body.classList.add('print')
          this.setState({printing: true}, function() {
            // console.log('ICI')
          });
        }
      }
      componentDidUpdate(oldProps) {
        const { missionId, ficheId, profile, anon } = this.props;

        if ((oldProps.$$data === undefined && this.props.$$data !== undefined) || (oldProps.$$data !== undefined && this.props.$$data !== undefined && oldProps.$$data.get('fiche').get('id') !== this.props.$$data.get('fiche').get('id'))) {
          const URI = queryString.parse(this.props.location.search);
          // console.log('FIRST (play)')

          if (URI.print === 'true') {
            document.body.classList.add('print')
            this.setState({printing: true}, function() {
              // console.log('ICI2')
              setTimeout(function() {
                window.print();
                window.close();
              }, 50);
            });
          } else {
            // console.log('SECOND (play)')
            const { $$data } = this.props;
            const $$fiche = $$data !== undefined ? $$data.get('fiche') : undefined;

            const $$video = $$fiche.get('video_files').get(0);
            // console.log($$video.toJS())
            if ($$video)
              this._playVideo($$video, false);
            else
              this.setState({videoUrl:undefined});
          }
        }

        if ((oldProps.missionId !== undefined && oldProps.missionId !== this.props.missionId) || (oldProps.ficheId !== undefined && oldProps.ficheId !== this.props.ficheId)) {
          let url;
          if (!anon && !profile)
            url = config.fiche.replace(':missionId', missionId).replace(':ficheId', ficheId);
          else if (profile)
            url = config.profile;

        this.props.onMount(url);
        }


      }
      _modalOpen() {
        this.setState({modalState: true})
      }
      _modalClose() {
        this.setState({modalState: false})
      }
      _hasPrevious() {
        const { missionId } = this.props;
        if (missionId === MISSION_ID_360 || missionId === undefined || missionId === 'anon') return false;
        const currentIndex = this._getFicheIndex(this.props.ficheId);
        return (currentIndex !== 0)
      }
      _hasNext() {
        const { $$data, missionId } = this.props;
        if (missionId === MISSION_ID_360 || missionId === undefined || missionId === 'anon') return false;
        const currentIndex = this._getFicheIndex(this.props.ficheId);
        return (currentIndex < $$data.get('missions').get('details').size-1)
      }
      _getFicheIndex(ficheId) {
        const { $$data } = this.props;
        const currentIndex = $$data.get('missions').get('details').findIndex((d, i) => {
          return (d.get('id') === ficheId);
        });
        return currentIndex;
      }
      _prevNext(direction, missionId, ficheId) {
        const { $$data } = this.props;

        let newFicheId;
        const currentIndex = this._getFicheIndex(ficheId);
        switch(direction) {
          case 'previous':
          if (currentIndex === 0) return;
          else {
            newFicheId = $$data.get('missions').get('details').get(currentIndex -1).get('id');
          }
          break;
          default:
          case 'next':
          if (currentIndex === $$data.get('missions').get('details').size-1) return;
          else {
            newFicheId = $$data.get('missions').get('details').get(currentIndex +1).get('id');
          }
          break;
        }
        // console.log(newFicheId)
        if (newFicheId)
        this.props.history.push('/mission/'+missionId+'/fiche/'+newFicheId);
        // console.log('DDDD', this.props.history.push()
      }
      _getVideoUrl($$video, format) {
        let url = false;
        if ($$video.get('urls') === undefined || $$video.get('urls').size === 0) return false;
        $$video.get('urls').map((v) => {
          if (v.get('type') === format)
          url = v.get('path');
          return true;
        })
        return url;
      }
      _playVideo($$video, autoPlay) {
        const videoUrl = this._getVideoUrl($$video, 'video/mp4');
        if (videoUrl !== false) {
          this.setState({videoUrl, autoPlay});
          console.log('videoUrl is', videoUrl)
        } else {
          console.log('no mp4 found !!!')
        }
      }
      _print() {
        console.log(this.props.location)
        // const URI = queryString.parse(this.props.location);
        // console.log(URI)
        const URI = this.props.location;
        // console.log('URI IS', URI)
        window.open(URI.pathname+'?print=true', 'Print', 'width=400, height=200, menubar=no, toolbar=no, left=200, top=100');
      }
      render() {
        const { $$data, missionId, ficheId, width } = this.props;
        // const { missionId, ficheId } = this.props;
        // const $$data = undefined;

        const { printing, videoUrl, autoPlay } = this.state;
        const $$fiche = $$data !== undefined ? $$data.get('fiche') : undefined;
        const $$mission = $$data !== undefined && $$data.get('missions') && $$data.get('missions').get('index') ?  $$data.get('missions').get('index').find(obj => obj.get('id') === missionId) : undefined;
        // const $$mission = undefined;

        const hasNext = $$data !== undefined ? this._hasNext() : false;
        const hasPrevious = $$data !== undefined ? this._hasPrevious() : false;

        const showMore = !printing;
        return (
          <div id="fiche" className="Fiche">
            <Choose>
              <When condition={$$fiche !== undefined}>
                <ScrollToTopOnMount/>
                <div className="headerWrapper">
                <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start">
                  <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start" className="head">
                    <If condition={hasPrevious}>
                      <span className="previous"><a onClick={this._prevNext.bind(this, 'previous', missionId, ficheId)}><IconSetMenu icon={'previous'} /></a></span>
                    </If>
                    <If condition={hasNext}>
                      <span className="next"><a onClick={this._prevNext.bind(this, 'next', missionId, ficheId)}><IconSetMenu icon={'next'} /></a></span>
                    </If>
                    <If condition={missionId !== undefined && missionId !== 'anon' && missionId!==MISSION_ID_360}>
                      <Grid item xs={12} className="breadCrumbs">
                        <span><Link to={'/mission'}>Mes Missions</Link></span> &nbsp;/&nbsp; <span><Link to={'/mission/'+missionId}>{$$mission.get('code_mission')}</Link></span> &nbsp;/&nbsp; <span>Label N°{$$fiche.get('code_candidat')}</span>
                      </Grid>
                    </If>

                    <Grid item xs={12} md={4} className="summary">
                      <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start">
                        <Grid item xs={12} className="print">
                          <button onClick={this._print.bind(this)}><IconPrint className="icon"/>Imprimer le 360°</button>
                        </Grid>
                        <Grid item xs={12} sm={7} md={12}>
                          <div className="code">Le 360° de <em></em></div>
                          <div className="name">{$$fiche.get('prenom')} {$$fiche.get('nom')}</div>
                          <div className="job">{$$fiche.get('fonction_str')}</div>
                          <span className="spacer"></span>
                          <If condition={$$mission}>
                            <span className="mission">
                              <em>{$$mission.get('code_mission')}</em> <If condition={$$mission.get('type_poste')}>| <em>{$$mission.get('type_poste')}</em></If>
                              <span className="spacer"></span>
                            </span>
                          </If>
                        </Grid>
                        <Grid item xs={12} sm={5} md={12}>
                          <span className="buttons">
                            <If condition={$$fiche.get('cv') !== undefined && $$fiche.get('cv') !== false}>
                              <a href={$$fiche.get('cv')} className={'button cv'+($$fiche.get('cv') ? '' : ' disabled')}><span className="icon-big icon-cv"></span>Lire le CV</a>
                            </If>
                            <If condition={$$fiche.get('test') !== undefined && $$fiche.get('test') !== false}>
                              <a className={'button test'+($$fiche.get('test') ? '' : ' disabled')} onClick={this._modalOpen}><span className="icon-big test"></span>Voir le test de personnalité</a>
                            </If>
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>



                    <Grid item xs={12} md={8}>
                      <div className="videoWrapper">
                        <BlockRatio ratio={'16_9'}>
                          <div className="videoPlaceHolder">
                            <ReactPlayer url={videoUrl} playing={autoPlay} controls width="100%" height="100%"/>
                          </div>
                        </BlockRatio>
                      </div>
                      <div className="videoSelector">
                        <ul>
                          <li>
                            Vidéo{($$fiche.get('video_files').size > 1 ? 's' : '')} :</li>
                          <If condition={$$fiche.get('video_files').size > 0}>
                            {$$fiche.get('video_files').map((video, i) => {
                              return <li key={'video_'+i}>
                                <a onClick={this._playVideo.bind(this, video, true)}><IconPlay className="icon"/> {video.get('name')}</a>
                              </li>
                            }).toArray()}
                          </If>
                        </ul>

                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <div className="bodyWrapper">
                <div className="body">
                  <h3><IconLanguage className="icon"/> Languages</h3>
                  <div className="cell">
                    <MissionFicheBlock title={'Informatique'} content={$$fiche.get('informatique')} more={showMore} width={width} printing={printing}/>
                  </div>
                  <div className="cell">
                    <MissionFicheBlock title={'Langues'} content={$$fiche.get('langues')} more={showMore} width={width} printing={printing}/>
                  </div>


                  <h3><IconChat className="icon"/>  L'avis du recruteur</h3>
                  <div className="cell">
                    <MissionFicheBlock title={'Formation / Expérience professionnelle'} content={$$fiche.get('avis_formation')} more={showMore} width={width} printing={printing}/>
                  </div>
                  <div className="cell">
                    <MissionFicheBlock title={'Compétences / Savoir-faire'} content={$$fiche.get('avis_competences')} more={showMore} width={width} printing={printing}/>
                  </div>


                  <div className="cell">
                    <MissionFicheBlock title={'Personnalité'} content={$$fiche.get('avis_personnalite')} more={showMore} width={width} printing={printing}/>
                  </div>
                  <div className="cell">
                    <MissionFicheBlock title={'Perspectives dans l\'entreprise'} content={$$fiche.get('avis_perspective')} more={showMore} width={width} printing={printing}/>
                  </div>


                  <div className="cell">
                    <MissionFicheBlock title={'Points de vigilance'} content={$$fiche.get('avis_vigilence')} more={showMore} width={width} printing={printing}/>
                  </div>
                  <div className="cell">
                    <span className="padder infos">
                      <h4>Informations pratiques
                      </h4>
                      <span className="content">
                        <ul>
                          <If condition={$$fiche.get('salaire') !== ''}><li><IconSalary className="icon"/><span className="legend">Salaire :</span> <em>{$$fiche.get('salaire')} K&euro;</em></li></If>
                          <If condition={$$fiche.get('disponibilite_sous') !== ''}><li><IconCalendar className="icon"/><span className="legend">Préavis :</span> <em> {$$fiche.get('disponibilite_sous')}</em> </li></If>
                          <If condition={$$fiche.get('permis') !== ''}><li><IconCar className="icon"/><span className="legend">Permis :</span> <em>{$$fiche.get('permis')}</em> </li></If>
                          <If condition={$$fiche.get('ville') !== ''}><li><IconCity className="icon"/><span className="legend">Ville :</span> <em> {$$fiche.get('ville')}</em> </li></If>
                          <If condition={$$fiche.get('mobilite') !== ''}>
                            <li><IconMobility className="icon"/><span className="legend">Mobilité :</span><em> {$$fiche.get('mobilite')}</em> </li></If>
                          </ul>
                        </span>
                      </span>
                    </div>

                    <Modal
                      aria-labelledby="Test de personnalité"
                      aria-describedby="Test de personnalité"
                      open={this.state.modalState}
                      onClose={this._modalClose}

                      >
                      <div style={{top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: 'absolute'}} className={'Modal'}>
                        <div className="head">
                          <a className="close" onClick={this._modalClose}>x</a>
                          <h1>Test de personnalité</h1>
                        </div>
                        <div className="content">
                          <img src={$$fiche.get('test')} width="100%" height="100%" alt="Test" />
                        </div>
                      </div>
                    </Modal>
                  </div>
                  </div>
                </When>
                <Otherwise>
                  <div className={'Loading'}>
                    <Spinner style={{marginTop: 200}}>Chargement...</Spinner>
                  </div>
                </Otherwise>
              </Choose>
            </div>

          );
        }
      }

      function mapStateToProps(state) {
        const props = {
          $$data: getDataFiche(state),
          error: getLoadingError(state),
        };
        return props;
      }
      function mapDispatchToProps(dispatch) {
        return {
          onMount: (url) => dispatch(fetchData( {key: AF_KEY, fetchUrl: url})),
        };
      }


      export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MissionFiche));



// WEBPACK FOOTER //
// ./src/components/Mission/MissionFiche.jsx